import { Link, useLocation } from "react-router-dom";
import {
  frontendRoutes,
  LANDING_STAY_QUERY_PARAM,
} from "../../../utility/frontendRoutes";

// Returns props to spread onto a link element pointing at a landing page
// section. On the landing page a plain anchor keeps native in-page scrolling;
// elsewhere it routes to "/" (with the stay param so logged-in visitors aren't
// redirected to the feed) and LandingPage scrolls to the hash on mount.
const useLandingSectionLink = () => {
  const { pathname } = useLocation();
  const onLanding = pathname === frontendRoutes.LANDING;

  return (sectionId) =>
    onLanding
      ? { component: "a", href: `#${sectionId}` }
      : {
          component: Link,
          to: `${frontendRoutes.LANDING}?${LANDING_STAY_QUERY_PARAM}=true#${sectionId}`,
        };
};

export default useLandingSectionLink;
